export default "__VITE_ASSET__2c0f3084__"